module.exports = __webpack_public_path__ + "img/escudo.f6797b72.svg";